import { Link } from "react-router-dom";

const StudentsEmptyState = ({ role }) => {
  const isParent = role === "parent";

  return (
    <section className="students-empty-state">
      <p className="eyebrow">{isParent ? "My Kids" : "Students"}</p>
      <h1>Your reading journey starts here</h1>
      <p>
        {isParent
          ? "Create your first kid and assign their first challenge. Their code and PIN will help them begin reading with confidence."
          : "Create your first student and assign their first challenge. Their code and PIN will help them begin reading with confidence."}
      </p>
      <Link to="/dashboard/students/new" className="lms-primary-action students-empty-cta">
        {isParent ? "Create first kid" : "Create first student"}
      </Link>
    </section>
  );
};

export default StudentsEmptyState;
